import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-metrics",
  "use": "icon-metrics-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-metrics\"><path d=\"M1 13h14v1H1zm2-6h2v5H3zm4-5h2v10H7zm4 3h2v7h-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol